// @flow
/* eslint-env browser */

type Entry = [string, any];

function safeJSONParse(o: Object) {
  try {
    return JSON.parse(o);
  } catch (e) {
    return null;
  }
}

function ensureSessionStorage() {
  return typeof window !== 'undefined';
}

function getParsedEntry([key, value]): Entry {
  return [key, safeJSONParse(value)];
}

export function setInSessionStorage(key: string, value: Object) {
  return ensureSessionStorage() && sessionStorage.setItem(key, JSON.stringify(value));
}

export function getEntries(): $ReadOnlyArray<Entry> {
  return ensureSessionStorage() ? Object.entries(sessionStorage).map(getParsedEntry) : [];
}

export function getFromSessionStorage(key: string) {
  return ensureSessionStorage() && key ? safeJSONParse(sessionStorage.getItem(key)) : null;
}

export function clearSessionStorage() {
  return ensureSessionStorage() && sessionStorage.clear();
}

export function removeFromSessionStorage(key: string) {
  return ensureSessionStorage() && key && sessionStorage.removeItem(key);
}
